import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/commercial-consumers\/gas-metering-nodes\/query(?:\?.*)?$/)
  .reply(200, [])
  .onGet(/\/api\/commercial-consumers\/gas-metering-nodes\/([^/?]+)(?:\?.*)?$/)
  .reply(200, null)
  .onPost(/\/api\/commercial-consumers\/gas-metering-nodes\/?$/)
  .reply(200, {})
  .onPut(/\/api\/commercial-consumers\/gas-metering-nodes\/([^/?]+)(?:\?.*)?$/)
  .reply(200, {})
  .onAny()
  .passThrough();
